const defaultLabel = {
  '@type': '@builder.io/sdk:Element',
  component: {
    name: '_Text_',
    options: {
      text: 'Size Guide Tab',
    },
  },
};

const defaultContent = {
  '@type': '@builder.io/sdk:Element',
  component: {
    name: 'Box',
    options: {},
  },
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: '_Asset_',
        options: {
          type: 'image',
          container: null,
          mobileContainer: null,
        },
      },
    },
  ],
};

const FableticsSizeGuideTabsBuilderComponent = {
  name: '_SizeGuideTabs_',
  canHaveChildren: true,
  inputs: [
    {
      name: 'tabs',
      type: 'list',
      subFields: [
        {
          name: 'tabId',
          type: 'string',
          defaultValue: 'size-guide-1',
          localized: false,
          required: true,
          helperText: 'Unique identifier for this tab',
        },
        {
          name: 'label',
          type: 'uiBlocks',
          defaultValue: [defaultLabel],
          localized: false,
          helperText: 'Tab label displayed at the top',
        },
        {
          name: 'content',
          type: 'uiBlocks',
          defaultValue: [defaultContent],
          localized: false,
          helperText:
            'Tab content. Contains a Box with a preloaded AssetNode. Configure the container field in the AssetNode to specify CMS asset containers for size charts, measurement guides, and fit images.',
        },
      ],
      helperText: 'Add multiple tabs for different guides (e.g. size, fabric)',
    },
  ],
} as const;

export default FableticsSizeGuideTabsBuilderComponent;
